import React, { useEffect, useRef } from 'react';

import dabangBridge from '~/utils/bridge';
import BG from '~/components/background';

import mainImg from './images/main.png';

import { Btn, BtnWrap } from './styled';

function SignRegionExpandEvent() {
  const _dom = useRef(null);
  const _btn = useRef(null);

  useEffect(() => {
    calcPos();
    window.addEventListener('resize', calcPos, false);

    return () => {
      window.removeEventListener('resize', calcPos);
    }
  }, []);

  function calcPos() {
    const rect = _dom.current.getBoundingClientRect()
    _btn.current.style.height = `${rect.height}px`;

    const screenWidth = document.documentElement.clientWidth;
    const bodyWidth = document.body.clientWidth;
    const space = screenWidth - bodyWidth;

    if (space > 0) {
      _btn.current.style.left = `${space / 2}px`;
    } else {
      _btn.current.style.left = `0px`;
    }
  }

  function goSignRoomList() {
    const params = {
      api_type: 'BBOX',
      location: JSON.stringify([[125.38564393561512,32.320189184386535],[129.9669425751472,38.85305442043736]]),
      zoom: 9,
    };

    dabangBridge.web(call => {
      console.log('web');
      window.location.href = `https://dabangapp.com/search/map?filters=%7B%22multi_room_type%22%3A%5B0%2C1%2C2%5D%2C%22selling_type%22%3A%5B0%2C1%2C2%5D%2C%22deposit_range%22%3A%5B0%2C999999%5D%2C%22price_range%22%3A%5B0%2C999999%5D%2C%22trade_range%22%3A%5B0%2C999999%5D%2C%22maintenance_cost_range%22%3A%5B0%2C999999%5D%2C%22room_size%22%3A%5B0%2C999999%5D%2C%22supply_space_range%22%3A%5B0%2C999999%5D%2C%22room_floor_multi%22%3A%5B1%2C2%2C3%2C4%2C5%2C6%2C7%2C-1%2C0%5D%2C%22division%22%3Afalse%2C%22duplex%22%3Afalse%2C%22room_type%22%3A%5B1%2C2%5D%2C%22use_approval_date_range%22%3A%5B0%2C999999%5D%2C%22parking_average_range%22%3A%5B0%2C999999%5D%2C%22household_num_range%22%3A%5B0%2C999999%5D%2C%22parking%22%3Afalse%2C%22short_lease%22%3Afalse%2C%22full_option%22%3Afalse%2C%22built_in%22%3Afalse%2C%22elevator%22%3Afalse%2C%22balcony%22%3Afalse%2C%22safety%22%3Afalse%2C%22pano%22%3Afalse%2C%22is_contract%22%3Afalse%2C%22deal_type%22%3A%5B0%2C1%5D%7D&position=%7B%22location%22%3A%5B%5B126.2728908%2C37.1952243%5D%2C%5B127.7560451%2C37.792317%5D%5D%2C%22center%22%3A%5B127.01446798508894%2C37.494367328004216%5D%2C%22zoom%22%3A11%7D&search=%7B%22id%22%3A%22%22%2C%22type%22%3A%22%22%2C%22name%22%3A%22%22%7D&tab=all`;
    });

    dabangBridge.android(call => {
      console.log('android');
      call.signRoomList(JSON.stringify(params));
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'signRoomList',
        params: params,
      });
    });
  }

  return (
    <>
      <BG width={710} height={1264} imgUrl={mainImg} />
      <BtnWrap ref={_dom}>
        <Btn ref={_btn} onClick={goSignRoomList} />
      </BtnWrap>
    </>
  );
}

export default SignRegionExpandEvent;
